<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="footsteps">
<h1>Footsteps</h1>
<p style="text-indent:0em !important">Do you know what loneliness sounds like?</p>
<p style="text-indent:0em !important">I think it sounds like nothing</p>
<p style="text-indent:0em !important">after a door shuts,</p>
<p style="text-indent:0em !important">footsteps on the stairs that you know</p>
<p style="text-indent:0em !important">aren’t meant for you,</p>
<p style="text-indent:0em !important">the inside of your head being</p>
<p style="text-indent:0em !important">a little too loud.</p>
<p style="text-indent:0em !important">And sometimes it sounds like</p>
<p style="text-indent:0em !important">the beat of your heart</p>
<p style="text-indent:0em !important">turning into a drumroll</p>
<p style="text-indent:0em !important">with no one to calm it down</p>
<p style="text-indent:0em !important">but you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?9e2d4df2